<template>
  <kudo-card>
    <kudo-block class="flex flex-col gap-y-4">
      <div class="flex justify-between items-center">
        <p class="font-medium text-base">
          Overview
        </p>
        <nuxt-link :to="OVERVIEW_STEP_PATH">
          <kudo-button
            color-variant="flat"
            shape-variant="thin"
            class="!p-1 !py-0"
          >
            <i class="far fa-edit" />
            Edit
          </kudo-button>
        </nuxt-link>
      </div>
      <kudo-attribute
        v-for="(item, index) in overviewItems"
        :key="index"
        :label-text="item.label"
        class="flex flex-col"
      >
        <span>{{ item.value }}</span>
      </kudo-attribute>
    </kudo-block>
  </kudo-card>
</template>

<script setup>
import { KudoCard, KudoButton, KudoBlock, KudoAttribute } from '@openly-engineering/kudo'
import { openlyCatTypeOption, OVERVIEW_STEP_PATH, pcsTypeOption } from './cat-tag-utils'

const { $store } = useNuxtApp()
const overviewFormData = computed(() => $store.getters['adminClaims/getFormDataByStepPath'](OVERVIEW_STEP_PATH))
const isOpenlyCAT = computed(() => overviewFormData.value.type === openlyCatTypeOption.value)

const overviewItems = computed(() => {
  const declarerAttribute = { label: 'Declarer', value: isOpenlyCAT.value ? openlyCatTypeOption.label : pcsTypeOption.label }
  const catNumberAttribute = { label: 'CAT Number', value: overviewFormData.value.pcsNumber }
  const catDetailsAttribute = { label: 'CAT Details', value: overviewFormData.value.description }

  if (isOpenlyCAT.value) { return [declarerAttribute, catDetailsAttribute] }
  return [declarerAttribute, catNumberAttribute, catDetailsAttribute]
})

</script>
